export const RANK_COLUMNS = [
  "runGameRank",
  "passGameRank",
  "onslaughtRank",
  "defenseRank",
];

export function toMatchupRows(rankings) {
  return rankings.map((row) => ({
    ...row,
    team: `${row.team.abbreviation} ${row.team.name}`,
    opp: `${row.opp.abbreviation} ${row.opp.name}`,
  }));
}

export function buildMatchupColumns(offense) {
  const base = [
    { Header: "Team", accessor: "team", sortDescFirst: false },
    { Header: "Opp", accessor: "opp", sortDescFirst: false },
    { Header: "Game Total", accessor: "gameTotal" },
    { Header: "Team Total", accessor: "teamTotal" },
  ];

  if (offense) {
    return base.concat([
      { Header: "Run Game Rank", accessor: "runGameRank", sortDescFirst: false },
      { Header: "Pass Game Rank", accessor: "passGameRank", sortDescFirst: false },
      {
        Header: "Team Onslaught Rank",
        accessor: "onslaughtRank",
        sortDescFirst: false,
      },
    ]);
  }

  return base.concat([
    { Header: "Defense Rank", accessor: "defenseRank", sortDescFirst: false },
  ]);
}

export function rankQuartile(value, rowCount) {
  if (typeof value !== "number" || !rowCount) {
    return null;
  }
  const groupSize = Math.max(1, Math.floor(rowCount / 4));
  if (value <= groupSize) {
    return 1;
  }
  if (value <= groupSize * 2) {
    return 2;
  }
  if (value <= groupSize * 3) {
    return 3;
  }
  return 4;
}

export function rankCellProps(rowCount) {
  return (cell) => {
    if (!RANK_COLUMNS.includes(cell.column.id)) {
      return {};
    }
    const quartile = rankQuartile(cell.value, rowCount);
    return quartile ? { className: `nfl-rank-q${quartile}` } : {};
  };
}
